import _ from 'lodash-es';
import React from 'react';
import { Table, } from 'tea-component';
import { useIntl } from 'umi';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import Loading from '@/pages/intelligence/components/Loading';

const { scrollable, pageable } = Table.addons;

export default React.forwardRef((props: any, ref: any) => {

  const {
    records,
    columns,
    loading,
    pageIndex = 1,
    setPageIndex,
  } = props;

  // console.log('SourceTable', props);

  const { formatMessage } = useIntl(); // 中英切换方法
  const loadingOrNodata = loading || records?.length === 0;
  const total = records?.length;

  const handleOnChangePageIng = (value: any) => {
    setPageIndex && setPageIndex(value.pageIndex);
  }

  return (
    <CardSlot>
      <div
        ref={ref}
        style={{ position: 'relative' }}
      >
        <div
          style={{
            display: loadingOrNodata ? 'block' : 'none',
            position: 'absolute',
            width: '-webkit-fill-available',
            zIndex: 9999,
            textAlign: 'center',
            bottom: 122,
          }}
        >
          {loading ? (
            <Loading />
          ) : _.isEmpty(records) ? (
            formatMessage({ id: 'common_nodata' })
          ) : (
            ''
          )}
        </div>
        <Table
          recordKey={'app_id'}
          records={loading ? [] : (records || [])}
          columns={columns}
          className='dbi-source-metrics-table'
          addons={[
            pageable({
              // stateTextVisible: total > 10,
              pageSizeVisible: total > 10,
              pageIndexVisible: total > 10,
              jumpVisible: total > 10,
              endJumpVisible: total > 10,
              pageIndex: pageIndex,
              onPagingChange: handleOnChangePageIng,
            }),
            scrollable({
              minWidth: 'auto',
              maxHeight: '100%',
              minHeight: loadingOrNodata ? '158px' : 'auto',
            }),
          ]}
        />
      </div>
    </CardSlot>

  );
});
